import { FormGroup } from '@angular/forms';
import { InjectionToken } from '@angular/core';
import { PostosRelatorios } from '@home/submodulos/dados-meteorologicos/interfaces/tabela-relatorio';
import {
	Estacao,
	Municipio,
} from '@home/submodulos/dados-meteorologicos/interfaces/filtros-opcoes';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';
import { Select } from '@layout/interfaces/select';
import moment from 'moment';
import { TiposDatePicker } from '@shared/interfaces/date-picker';
import { DataPrimeiraColetaPCD } from '../submodulos/monitoramento/pages/estacoes-automaticas/data-primeira-coleta-pcd';
import { BehaviorSubject } from 'rxjs';

interface InputsRelatorio {
	form: FormGroup;
	postos: PostosRelatorios[];
	postosSudene: Select[];
	estacoes: Estacao[];
	regioes: Select[];
	microrregioes: Select[];
	mesorregioes: Select[];
	precipitacao: Select[];
	municipioPostos: Select[];
	municipios: Municipio[];
	agrupamentos: Select[];
	bacias: Select[];
	subBacias: Select[];
	setLoading: (state: boolean) => void;
	setCondicoesMostrarItensForm: (fucoesForm: CondicoesMostrarItensForm) => void;
}

interface InputsRelatorioPCDs extends InputsRelatorio {
	datasPrimeirasColetasPCDs: DataPrimeiraColetaPCD[];
	mensagemDataMinima?: string;
	triggerTrocaMensagemDataMin$: BehaviorSubject<string | undefined>;
	triggerTrocaDataMin$: BehaviorSubject<Date | undefined>;
}

interface InputsRelatorioQuantis {
	form: FormGroup;
	agrupamentos: Select[];
	estacoes: Estacao[];
	regioes: Select[];
	microrregioes: Select[];
	municipios: Municipio[];
	setLoading: (state: boolean) => void;
	setCondicoesMostrarItensForm: (fucoesForm: CondicoesMostrarItensForm) => void;
}
export interface ConjuntoLabelsDinamicasPeriodo {
	inicio?: LabelDinamicaPeriodo;
	fim?: LabelDinamicaPeriodo;
	unico?: LabelDinamicaPeriodo;
	mensal_por_nome?: boolean;
}
interface LabelDinamicaPeriodo {
	label: string;
	placeholder: string;
	dataType: TiposDatePicker;
}

export enum FormularioRelatorio {
	CATEGORIA = 'categoria',
	FORMATO = 'formato',
	TIPO = 'tipo',
	TIPO_PCD = 'tipoPCD',
	VARIAVEL = 'variavel',
	VARIAVEL_ACOMPANHAMENTO_COLETA = 'variavelAcompanhamentoColeta',
	DATA_INICIO_JANELA_TEMPO = 'dataInicioJanelaTempo',
	DATA_FIM_JANELA_TEMPO = 'dataFimJanelaTempo',
	DATA_INICIO = 'dataInicio',
	DATA_FIM = 'dataFim',
	MES_INICIO = 'mesInicio',
	MES_FIM = 'mesFim',
	POSTO = 'posto',
	POSTO_SUDENE = 'postoSudene',
	ESTACAO = 'estacao',
	PERIODO = 'periodo',
	MICRORREGIAO = 'microrregiao',
	MESORREGIAO = 'mesorregiao',
	MUNICIPIO = 'municipio',
	PRECIPITACAO = 'precipitacao',
	LOADING_GERAR = 'loadingGerar',
	VARIAVEL_MAPA = 'variavelMapa',
	VARIAVEL_GRAFICO = 'variavelGrafico',
	TIPO_PERIODO = 'tipoPeriodo',
	TIPO_MAPA = 'tipoMapa',
	TIPO_GRAFICO = 'tipoGrafico',
	JANELA_TEMPO = 'janelaTempo',
	AGRUPAMENTO = 'agrupamento',
	PERIODO_BUSCA = 'periodoBusca',
	TIPO_VISUALIZACAO = 'tipoVisualizacao',
	PERIODO_CHUVOSO = 'periodoChuvoso',
	REGIAO_PLUVIOMETRICA = 'regiao',
	VARIAVEIS_MOSAICO = 'variaveisMosaico',
	BACIA = 'bacia',
	SUB_BACIA = 'subBacia',
	MAPA_PRECIPITACOES = 'mapaPrecipitacoes',
	RADIO_POSTOS = 'radioPostos',
	TIPO_MODO = 'tipoModo',
	NOME = 'nome',
	EMAIL = 'email',
	RESERVATORIO = 'reservatorio',
	COLETA = 'coleta',
	CAMPANHA = 'campanha',
	CULTURA = 'cultura',
}

export const INPUTS_RELATORIOS = new InjectionToken<InputsRelatorio>(
	'Inputs dos relatórios'
);

export const INPUTS_RELATORIOS_PCDS = new InjectionToken<InputsRelatorioPCDs>(
	'Inputs dos relatórios de PCDs'
);

export const INPUTS_RELATORIOS_QUANTIS =
	new InjectionToken<InputsRelatorioQuantis>(
		'Inputs dos relatórios de quantis'
	);

export interface InstanciaRelatorio {
	form?: FormGroup;
	postos?: PostosRelatorios[];
	estacoes?: Estacao[];
	regioes?: Select[];
	bacias?: Select[];
	microrregioes?: Select[];
	mesorregioes?: Select[];
	opcoesMunPostos?: Select[];
	municipios?: Municipio[];
	precipitacao?: Select[];
	tiposPCD?: Select[];
	variaveisGrafico?: Select[];
	variaveisMosaico?: Select[];
	gerarRelatorio: () => void;
	atualizarOpcoesFormulario?: () => void;
	agrupamento?: Select[];
	botoesDeExportacao?: GroupButton[];
}

export type PeriodosComponenteRelatorio = Partial<{
	[K in PeriodosLabel]: PeriodosInterface;
}>;

export interface ComponenteRelatorio {
	componente?: any;
	periodos?: PeriodosComponenteRelatorio;
	usaSetagemPropriaDatas?: boolean;
	impedirGeracaoRelatorioAutomatica?: boolean;
	camposComEstadoCompleto?: FormularioRelatorio[];
	condicoesMostrarItensForm?: CondicoesMostrarItensForm;
	inputs?: { form: FormGroup };
}

export interface PeriodosInterface {
	minAmount?: moment.DurationInputArg1;
	amount?: moment.DurationInputArg1;
	unit?: moment.unitOfTime.DurationConstructor | undefined;
	apenasMesmoAno?: boolean;
}

export type PeriodosLabel =
	| 'horario'
	| 'diario'
	| 'mensal'
	| 'anual'
	| 'mensal_unico'
	| 'anual_unico'
	| 'mensal_completo'
	| 'anual_completo'
	| 'mensal_parcial'
	| 'anual_parcial'
	| 'mensal_por_nome'
	| 'mensal_anual_parcial';

export type PeriodosLabelLinha =
	| 'horario'
	| 'diario'
	| 'mensal'
	| 'anual'
	| 'anual_parcial';

export const periodosLabelArray: PeriodosLabel[] = [
	'horario',
	'diario',
	'mensal',
	'anual',
	'anual_parcial',
	'mensal_anual_parcial',
	'mensal_unico',
	'anual_unico',
	'mensal_por_nome',
];

export type ListaRelatorios = {
	PLUVIOMETRICO: {
		GRAFICO: {
			SPI: ComponenteRelatorio;
			PLUVIOMETRIA_OBSERVADA: ComponenteRelatorio;
			DESVIO_MILIMETRO: ComponenteRelatorio;
			DESVIO_PORCENTAGEM: ComponenteRelatorio;
			CLIMATOLOGIA: ComponenteRelatorio;
			NUMERO_DIAS_COM_CHUVA: ComponenteRelatorio;
			DESVIO_POR_PERIODO_PORCENTAGEM: ComponenteRelatorio;
			DESVIO_POR_PERIODO_MM: ComponenteRelatorio;
			IAPM: ComponenteRelatorio;
		};
		MAPA: {
			PLUVIOMETRIA_INTERPOLADA: ComponenteRelatorio;
			IAPM: ComponenteRelatorio;
			PLUVIOMETRIA_OBSERVADA: ComponenteRelatorio;
			DESVIO_MILIMETRO: ComponenteRelatorio;
			DESVIO_PORCENTAGEM: ComponenteRelatorio;
			MOSAICO_CHUVAS: ComponenteRelatorio;
			CLIMATOLOGIA: ComponenteRelatorio;
			NUMERO_DIAS_COM_CHUVA: ComponenteRelatorio;
		};
		TABELA: {
			PRECIPITACAO_DIARIA: ComponenteRelatorio;
			PRECIPITACAO_MENSAL: ComponenteRelatorio;
			PRECIPITACAO_ANUAL: ComponenteRelatorio;
			ESTATISTICA_MENSAL: ComponenteRelatorio;
			DESVIOS_MENSAIS_ANUAIS: ComponenteRelatorio;
			HISTORICO_DA_SUDENE: ComponenteRelatorio;
			NUMERO_DIAS_COM_CHUVA: ComponenteRelatorio;
			DESVIO: ComponenteRelatorio;
			VALORES_EXTREMOS_PLUVIOMETRIA: ComponenteRelatorio;
			CLIMATOLOGIA: ComponenteRelatorio;
			SPI: ComponenteRelatorio;
			PLUVIOMETRIA_OBSERVADA: ComponenteRelatorio;
			IAPM: ComponenteRelatorio;
			DESVIO_POR_PERIODO: ComponenteRelatorio;
		};
	};
	PCD: {
		MAPA: {
			VARIAVEL_METEOROLOGICA_INTERPOLADA: ComponenteRelatorio;
			MOSAICO_VARIAVEL_METEOROLOGICA: ComponenteRelatorio;
			VARIAVEL_METEOROLOGICA_ESTACAO: ComponenteRelatorio;
		};
		GRAFICO: {
			VARIAVEL_METEOROLOGICA: ComponenteRelatorio;
		};
		TABELA: {
			EVAPOTRANSPIRACAO: ComponenteRelatorio;
			VALORES_EXTREMOS: ComponenteRelatorio;
			VARIAVEL_METEOROLOGICA: ComponenteRelatorio;
		};
	};
	QUANTIS: {
		MAPA: {
			QUANTIS: ComponenteRelatorio;
		};
		GRAFICO: {
			QUANTIS: ComponenteRelatorio;
		};
		TABELA: {
			QUANTIS: ComponenteRelatorio;
		};
	};
};

export type ValoresFormularioRelatorio = {
	[P in FormularioRelatorio]: any;
};

export type CondicoesMostrarItensForm = {
	[k in FormularioRelatorio]?: (val: ValoresFormularioRelatorio) => boolean;
};
